<script setup lang="ts">
import {storeToRefs} from "pinia";
import {DashboardRangeStore} from "@/scripts/store/dashboard_range.store";
import {useAnalytics} from "@/scripts/store/analytics";
import VLoader from "@/scripts/components/app/common/VLoader.vue";
import {ref} from "vue";
import {useAccount} from "@/scripts/store/account";

export interface Props {
    codeIdentifier: String
}

const props = defineProps<Props>();
const isLoading = ref(false)

const dashboardRange = DashboardRangeStore()
const analytics = useAnalytics();

const {currentRange} = storeToRefs(dashboardRange)

const subscription = useAccount()
const {account} = storeToRefs(subscription);
const {codeTrends} = storeToRefs(analytics);
const isAvailableForCurrentPlan = account.value.currentPlan.label !== 'free'

const load = async () => {
    if (!isAvailableForCurrentPlan) {
        return
    }

    isLoading.value = true
    await analytics.loadCodeTrends(currentRange.value.from, currentRange.value.to, props.codeIdentifier)
    isLoading.value = false
}

dashboardRange.$subscribe((mutation, state) => {
    load()
})

load()

</script>

<template>
    <div class="bg-white overflow-hidden shadow sm:rounded-lg">
        <div class="px-4 py-5 sm:p-6">
            <div>
                Топ QR кодов
            </div>
            <div v-if="isAvailableForCurrentPlan">
                <div v-if="!isLoading" class="mt-2">
                    <table class="w-full">
                        <thead class="bg-gray-50">
                        <tr>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider">
                                Название
                            </th>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider">
                                Сканирований
                            </th>
                        </tr>
                        </thead>
                        <tr v-for="(code, qrCodeIdx) in codeTrends"
                            :class="qrCodeIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'">
                            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                {{ code.title }}
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                {{ code.count }}
                            </td>
                        </tr>
                    </table>
                </div>
                <div v-else>
                    <v-loader class="mt-2"></v-loader>
                </div>
            </div>
            <div class="mt-8" v-else>
                <span
                    class="cursor-pointer inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                    <a href="/billing">
                        недоступно на free плане
                    </a>
                </span>
            </div>
        </div>
    </div>
</template>


